import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixPauseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M18.5625 2.15625H15.2812C14.6772 2.15625 14.1875 2.64594 14.1875 3.25V20.75C14.1875 21.3541 14.6772 21.8438 15.2812 21.8438H18.5625C19.1666 21.8438 19.6562 21.3541 19.6562 20.75V3.25C19.6562 2.64594 19.1666 2.15625 18.5625 2.15625Z"
        fill="currentColor"
      />
      <path
        d="M8.71875 2.15625H5.4375C4.83344 2.15625 4.34375 2.64594 4.34375 3.25V20.75C4.34375 21.3541 4.83344 21.8438 5.4375 21.8438H8.71875C9.32281 21.8438 9.8125 21.3541 9.8125 20.75V3.25C9.8125 2.64594 9.32281 2.15625 8.71875 2.15625Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
